import { GridItem } from '@chakra-ui/react';
import Input from 'src/components/input';
import { useUserCache } from 'src/apollo/cache';
import PasswordField from 'src/components/input/PasswordField';
import { InputLabelInsideFormControl } from 'src/components/input/InputLabelInside';
import { useFormContext } from 'react-hook-form';
import { FormValues } from '../form/FormValues';

export default function BasicFields() {
  const user = useUserCache();

  const {
    register,
    formState: { errors },
  } = useFormContext<FormValues>();

  return (
    <>
      <GridItem colSpan={[2, 1]}>
        <InputLabelInsideFormControl
          id="firstName"
          label="First name:"
          invalid={!!errors.firstName}
          errorMessage={String(errors.firstName?.message)}
          disabled={!!user?.firstName}
        >
          <Input
            {...register('firstName')}
            variation="label-inside"
            placeholder="John"
            autoComplete="given-name"
          />
        </InputLabelInsideFormControl>
      </GridItem>
      <GridItem colSpan={[2, 1]}>
        <InputLabelInsideFormControl
          id="lastName"
          label="Last name:"
          invalid={!!errors.lastName}
          errorMessage={String(errors.lastName?.message)}
          disabled={!!user?.lastName}
        >
          <Input
            {...register('lastName')}
            variation="label-inside"
            placeholder="Appleseed"
            autoComplete="family-name"
          />
        </InputLabelInsideFormControl>
      </GridItem>
      <GridItem colSpan={2}>
        <InputLabelInsideFormControl
          id="email"
          label="Email address:"
          invalid={!!errors.email}
          errorMessage={String(errors.email?.message)}
          disabled={!!user?.email}
        >
          <Input
            {...register('email', {
              // ignore leading/trailing spaces in email field
              setValueAs: value => value.trim(),
            })}
            variation="label-inside"
            placeholder="john@example.com"
            autoComplete="email"
          />
        </InputLabelInsideFormControl>
      </GridItem>
      <GridItem colSpan={2}>
        <PasswordField disabled={!!user?.email} />
      </GridItem>
    </>
  );
}
